import React, { useEffect, useMemo } from 'react'
import SelectInput from 'components/common/SelectInput'
import { generateHoursList } from 'utils/dateUtils'
import { NEW_RULE_DEFAULT_EXECUTION_HOUR } from 'consts/automatedActionConsts'

const RuleExecutionHourInput = ({ value, onChange = () => {}, defaultHour = NEW_RULE_DEFAULT_EXECUTION_HOUR }) => {
  const options = useMemo(() => generateHoursList(60, '00:00', '23:00', 'HH:mm'), [])

  useEffect(() => {
    if (!value) {
      onChange(defaultHour)
    }
  }, [onChange, value, defaultHour])

  return (
    <SelectInput
      value={value}
      onChange={({ value }) => onChange(value)}
      options={options}
      style={{ bright: true, thick: false }}
      selectStyle={{ border: 0, borderBottom: '0.75px solid var(--border-color-33)' }}
      keepErrorContainerWhenInactive={false}
    />
  )
}

export default RuleExecutionHourInput
